import { isDev } from './is-dev.fn';

export async function fetchCount(): Promise<string | undefined> {
  if (isDev()) {
    return Promise.resolve('12');
  } else {
    const response = await fetch('/count');
    const body: { count: number } | null | undefined = await response.json();

    if (body) {
      return body.count.toString();
    }

    return undefined;
  }
}
